import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SenderService {
  shareddata : boolean;
  constructor() { } 
  setOption(option, value) {      
    this. shareddata[option] = value;  
  }  
  
  getOption() {  
    return this. shareddata;  
  }  
}
